import { Alert } from '@idaho-aeyc/ui-kit';
import { styled } from 'styled-components';

export const SAlert = styled(Alert)``;
